import React, { useCallback, useEffect, useState } from 'react';
import { supabaseClient } from '@/services/supabase';
import { needsSecurityEnrollment } from '@/services/authSecurity';
import { SecurityEnrollmentScreen } from './SecurityEnrollmentScreen';
import { PageLoading } from '@/components/PageLoading';

type SecurityEnrollmentGateProps = {
    children: React.ReactNode;
};

export const SecurityEnrollmentGate: React.FC<SecurityEnrollmentGateProps> = ({ children }) => {
    const [isChecking, setIsChecking] = useState(true);
    const [enrollmentRequired, setEnrollmentRequired] = useState(false);

    const refreshEnrollmentRequirement = useCallback(async () => {
        setIsChecking(true);
        try {
            setEnrollmentRequired(await needsSecurityEnrollment());
        } catch (error) {
            console.error('Failed to check security enrollment requirement:', error);
            setEnrollmentRequired(false);
        } finally {
            setIsChecking(false);
        }
    }, []);

    useEffect(() => {
        void refreshEnrollmentRequirement();
    }, [refreshEnrollmentRequirement]);

    useEffect(() => {
        const { data: { subscription } } = supabaseClient.auth.onAuthStateChange(() => {
            void refreshEnrollmentRequirement();
        });
        return () => subscription.unsubscribe();
    }, [refreshEnrollmentRequirement]);

    if (isChecking) {
        return <PageLoading />;
    }

    if (enrollmentRequired) {
        return (
            <SecurityEnrollmentScreen
                onComplete={() => void refreshEnrollmentRequirement()}
            />
        );
    }

    return <>{children}</>;
};
